var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.6863 24.3137L3.37258 13L14.6863 1.68629","stroke":"white","strokeWidth":"4"}));
}

LeftArrow.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
